export default __webpack_public_path__ + "static/media/pic2.01c65e8f.jpg";